import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MenuConfigurationSearch from "../MenuConfigurationSearch";
import MenuConfigurationCategoriesTable from "./MenuConfigurationCategoriesTable";
const MenuConfigurationCategories = () => {
  const { categories } = useSelector((state) => state.menuConfigurationReducer);
  const [dataSource, setDataSource] = useState(categories);
  const [filterTable, setFilterTable] = useState(null);

  useEffect(() => {
    setDataSource(categories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  return (
    <>
      <div className="menu-configuration-categories-container">
        <MenuConfigurationSearch
          tabSelected="categories"
          categoriesDataSource={dataSource}
          setFilterTable={setFilterTable}
        />
      </div>
      <MenuConfigurationCategoriesTable
        filterTable={filterTable}
        categoriesDataSource={dataSource}
        setCategoriesDataSource={setDataSource}
      />
    </>
  );
};

export default MenuConfigurationCategories;
